import { Portal, PortalProps } from "components/Portal";
import React from "react";
const snackbarRoot = document.getElementById("snackbar-root")!;

interface SnackbarPortalProps extends Omit<PortalProps, "parentEl"> {}

export const SnackbarPortal = ({ children }: SnackbarPortalProps) => {
  return <Portal parentEl={snackbarRoot} children={children} />;
};
